import request from "@/utils/request";
const PREFIX_URL = process.env.NODE_ENV === 'development' ? '' : ''

export function getInstantSale(params) {
  return request.post('/operation/sellerAssistant/instantSale', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function getInstantSaleTime() {
  return request.get('/operation/dashboard/marketTime')
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

// 获取今日看板-销售看板
export function getTodaySaleBoard(params) {
    return request.post('/operation/dashboard/todaySaleBoard', params)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

// 获取今日看板-库存看板
export function getStockBoard(params) {
    return request.post('/supply/storageManage/dashboardStatistics', params)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

// 获取今日看板-结算看板


//获取看板时区列表
export function getTimezoneDate() {
    return request.get('/operation/dashboard/timezoneDate')
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

//获取节假日
export function getHoliday(param) {
    return request.get(`/operation/dashboard/holiday?${param}`)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

export function getWorkbench() {
    return request.get('/operation/workBench/tips')
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

// 新增排名和星级的分页查询
export function getSeaSellerAssistantPage(params) {
  return request.post(`${PREFIX_URL}/operation/sellerAssistant/page`, params)   
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

// 首页 商品销售看板
export function getItemSaleBoardPage(params) {
    return request.post(`${PREFIX_URL}/operation/dashboard/page`, params)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

// 首页 商品销售看板 异步查询 子asin列表
export function getItemSaleBoardPageDetail(params) {
    return request.post(`${PREFIX_URL}/operation/dashboard/detail`, params)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}


// 首页 商品销售看板--修改运营状态
export function editOperationStatus(params) {
    return request.post(`${PREFIX_URL}/operation/listing/editOperationStatus`, params)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

// 查询店铺授权类型
export function marketAuthType() {
    return request.post(`/base/market/marketAuthType`)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}


// 新增排名趋势图
export function getBsrInfo(params){
  return request.get(`${PREFIX_URL}/operation/dashboard/bsrInfo`,{params})
  .then((res)=>{
    return Promise.resolve(res.data);
  })
}

// 新增星级趋势图
export function getStarInfo(params){
  return request.get(`${PREFIX_URL}/operation/dashboard/starInfo`,{params})
  .then((res)=>{
    return Promise.resolve(res.data);
  })
}

// 商品销售看板 asin、父asin 获取批量调价数据
export function listingSaleBoard(params) {
    return request.post('/operation/listing/listingSaleBoard', params)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

// 系统更新公告
export function getSystemNotice(params) {
  return request.post('/manager/sysMsgsCenter/page', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function sysBanner() {
    return request.get('/manager/sysBanner/list')
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

// 贡献榜
export function getContributionRank(params) {
    return request.get('/operation/dashboard/contributionRanking', {params})
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

// 新晋人气榜
export function getPopularityRank(params) {
    return request.get('/operation/dashboard/popularityRanking', {params})
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

// 负豪榜
export function getNegativeRank(params) {
    return request.get('/operation/dashboard/negativeRanking', {params})
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

// 热销榜
export function getSaleHotRank(params) {
  return request.get('/operation/dashboard/sale/saleRank', {params})
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

// 滞销榜
export function getSaleLowRank(params) {
  return request.get('/operation/dashboard/sale/unsalableRank', {params})
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

// 退款榜
export function getSaleReturnRank(params) {
  return request.get('/operation/dashboard/sale/refundRank', {params})
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

// 缺货榜
export function getStorageLowRank(params) {
  return request.get('/operation/dashboard/sale/lackStorageRank', {params})
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

// 业绩贡献榜
export function getPerformanceRank(params) {
    return request.post('/operation/dashboard/performanceRanking', params)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

export function getSaleReport(params) {
  return request.get('/operation/dashboard/sale/chart', {params})
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function getAdReport(params) {
  // return request.get('/ads/dashboardAds/ads/chart', {params})
    return request.get('/ads/dashboard/chart', {params})
    .then((res) => {
      return Promise.resolve(res.data);
    });
}


// 获取全局消息提示
export function msgsGlobal() {
    return request.get('msgs/msg/v2/msgsGlobal')
        .then((res) => {
            return Promise.resolve(res.data);
        });
}
// 已读全局消息提示
export function msgsGlobalRead(params) {
    return request.post('/msgs/msg/v2/msgsGlobalRead', params)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

// 获取用户全部配置(布局、是否显示企业微信二维码)
export function getAllMap() {
    return request.get('base/customConfig/getAllMap')
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

// 广告即时看板--汇总数据
export function currentSummary(params) {
    return request.get('ads/dashboard/currentSummary'+params)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

// 广告即时看板--活动排名
export function currentCampaignRank(params) {
    return request.post('/ads/dashboard/currentCampaignRank', params)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

// 广告即时看板--关键词排名
export function currentKeywordRank(params) {
    return request.post('/ads/dashboard/currentKeywordRank', params)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

// 广告即时看板--活动hover
export function currentCampaignHover(params) {
    return request.get('ads/dashboard/currentCampaignHover'+params)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

// 广告即时看板--关键词hover
export function currentKeywordHover(params) {
    return request.get('ads/dashboard/currentKeywordHover'+params)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

// 索赔面板  -- 索赔统计
export function claimStatistics(params) {
    return request.post('/operation/claim/statistics', params)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}